// import "./dashboard.style.css";
// Card Images/Icons
import New_Created from "../../../assets/DashboardColoredIcons/New Created.svg"
import Pending_At_Auditor from "../../../assets/DashboardColoredIcons/Pending At Auditor.svg";
import Audited_By_Auditor from "../../../assets/DashboardColoredIcons/Audited by Auditor.svg";
import Pending_At_Auditee from "../../../assets/DashboardColoredIcons/Pending At Auditee.svg";
import Submitted_By_Auditee from "../../../assets/DashboardColoredIcons/Submitted By Auditee.svg";
import Closed from "../../../assets/DashboardColoredIcons/Closed.svg";

// Third Party Icons
import Draft from "../../../assets/DashboardColoredIcons/ThirdPartyAuditIcons/Draft.svg"
import Review_Pending from "../../../assets/DashboardColoredIcons/ThirdPartyAuditIcons/Review Pending.svg"
import Completed from "../../../assets/DashboardColoredIcons/ThirdPartyAuditIcons/Completed.svg"

// Background Colors for Card and it's Count
// New Created
const new_created_card_background = "#E3F0F6" 
const new_created_count_background =  "#CFE1E9"

// Pending At Auditor
const pending_at_auditor_card_background = "#EFE2F2"
const pending_at_auditor_count_background = "#E1C0E8"

// Audited By Auditor
const audited_by_auditor_card_background = "#E3F6F4"
const audited_by_auditor_count_background = "#D2EDD9"

// Pending At Auditee
const pending_at_auditee_card_background = "#FFEDD8"
const pending_at_auditee_count_background = "#FFDAAF"

// Submitted By Auditee
const submitted_by_auditee_card_background = "#E3E8F6"
const submitted_by_auditee_count_background = "#C3CFF0"

// Closed
const closed_card_background = "#FFEEEE"
const closed_count_background = "#FFD6D6"

// Audit Status config
const audit_status_config = {
  new: "New",
  pendingAtAuditor: "Pending At Auditor",
  audited: "Audited",
  pendingAtAuditee: "Pending At Auditee",
  submittedByAuditee: "Submitted By Auditee",
  closed: "Closed",
}

const third_party_status_config = {
  draft: "Draft",
  reviewPending: "Review Pending",
  completed: "Completed",
}

// Config for dashboard card layout
export const DashboardCardConfig = [
  {
    title: "New Created",
    statusType: "newAuditsCounts",
    count: 0,
    cardImage: New_Created,
    cardBackgroundColor: new_created_card_background,
    countBackgroundColor: new_created_count_background,
    status: audit_status_config.new,
  },
  {
    title: "Pending At Auditor",
    statusType: "pendingAtAuditorAuditsCount",
    count: 0,
    cardImage: Pending_At_Auditor,
    cardBackgroundColor: pending_at_auditor_card_background,
    countBackgroundColor: pending_at_auditor_count_background,
    status: audit_status_config.pendingAtAuditor,
  },
  {
    title: "Audited",
    statusType: "auditedAuditsCount",
    count: 0,
    cardImage: Audited_By_Auditor,
    cardBackgroundColor: audited_by_auditor_card_background,
    countBackgroundColor: audited_by_auditor_count_background,
    status: audit_status_config.audited,
  },
  {
    title: "Pending At Auditee",
    statusType: "pendingAtAuditeeAuditsCount",
    count: 0,
    cardImage: Pending_At_Auditee,
    cardBackgroundColor: pending_at_auditee_card_background,
    countBackgroundColor: pending_at_auditee_count_background,
    status: audit_status_config.pendingAtAuditee,
  },
  {
    title: "Submitted By Auditee",
    statusType: "submittedByAuditeeAuditsCount",
    count: 0,
    cardImage: Submitted_By_Auditee,
    cardBackgroundColor: submitted_by_auditee_card_background,
    countBackgroundColor: submitted_by_auditee_count_background,
    status: audit_status_config.submittedByAuditee,
  },
  {
    title: "Closed",
    statusType: "closedAuditsCount",
    count: 0,
    cardImage: Closed,
    cardBackgroundColor: closed_card_background,
    countBackgroundColor: closed_count_background,
    status: audit_status_config.closed,
  },
];

export const ThirdPartyAuditConfigData = [
  {
    title: "Draft",
    statusType: "draft",
    count: 0,
    cardImage: Draft,
    cardBackgroundColor: new_created_card_background,
    countBackgroundColor: new_created_count_background,
    status: third_party_status_config.draft,
  },
  {
    title: "Review Pending",
    statusType: "reviewPending",
    count: 0,
    cardImage: Review_Pending,
    cardBackgroundColor: pending_at_auditee_card_background,
    countBackgroundColor: pending_at_auditee_count_background,
    status: third_party_status_config.reviewPending,
  },
  {
    title: "Completed",
    statusType: "completed",
    count: 0,
    cardImage: Completed,
    cardBackgroundColor: audited_by_auditor_card_background,
    countBackgroundColor: audited_by_auditor_count_background,
    status: third_party_status_config.completed,
  },
]